import React, { type JSX } from 'react';
import clsx from 'clsx';
import moment from 'moment-timezone';
import { useTypedSelector } from '@fiji/common';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { useTransformData } from 'hooks/useTransformData';

export const WeekEventGrid = ({ event, gridWidth }: any): JSX.Element => {
    const selectedWeekDays = useTypedSelector((state) => state.schedule.selectedWeekDays);
    const currentTime = useTypedSelector((state) => state.schedule.currentTime);
    const { timezone } = useTransformData();

    const startDateTime = moment.tz(event?.actionStartTime, timezone);
    const endDateTime = moment.tz(event?.actionEndTime, timezone);
    const currentDateTime = moment.tz(currentTime, timezone);

    const startHour = startDateTime.hour();
    const startMinutes = startDateTime.minute();
    const topPosition = ((startHour * 60 + startMinutes) / 1440) * 100;

    return event?.schedules?.map((schedule: any) => {
        const scheduleMoment = moment.tz(schedule, timezone);
        const scheduleDay = scheduleMoment.format('dddd');
        const eventDayIndex = selectedWeekDays.findIndex((day: any) => day?.dayName === scheduleDay);
        const leftPosition = (eventDayIndex * gridWidth) / 7;

        const isOngoing =
            scheduleMoment.valueOf() <= currentDateTime.valueOf() &&
            endDateTime.hour() >= currentDateTime.hour() &&
            scheduleMoment.format('dd') === currentDateTime.format('dd');

        const isFuture = currentDateTime.valueOf() < scheduleMoment.valueOf();

        const isPast =
            (currentDateTime.hour() > endDateTime.hour() && currentDateTime.valueOf() > scheduleMoment.valueOf()) ||
            parseInt(scheduleMoment.format('D')) < parseInt(currentDateTime.format('D'));

        return event?.actionEndTime ? (
            <Grid
                style={{
                    position: 'absolute',
                    left: `${leftPosition}px`,
                    top: `${topPosition}%`,
                    height: `${((endDateTime.diff(startDateTime, 'minutes') / 60) * 100) / 24}%`,
                    zIndex: 1,
                }}
                key={schedule}
                className={clsx({
                    'ongoing-event': isOngoing,
                    'future-event': isFuture,
                    'past-event': isPast,
                })}
                size={12 / 7}
            >
                <Typography variant="body2" className="text-truncate">
                    {event?.name}
                </Typography>
            </Grid>
        ) : (
            <Stack
                sx={{
                    position: 'absolute',
                    left: `${leftPosition}px`,
                    top: `${topPosition}%`,
                    zIndex: 1,
                }}
                key={schedule}
                direction={'row'}
                spacing={1}
                alignItems={'center'}
                className={clsx({
                    'past-text-event': currentDateTime.valueOf() > startDateTime.valueOf(),
                    'future-text-event': currentDateTime.valueOf() < startDateTime.valueOf(),
                    'ongoing-text-event': currentDateTime.valueOf() === startDateTime.valueOf(),
                })}
            >
                <Box className="dot" />
                <Typography>{event?.name}</Typography>
            </Stack>
        );
    });
};
